module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/app-layouts/empty-layout.component.html
// module id = 901
// module chunks = 85